import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UtilService } from 'src/modules/base/services/util.service';

@Component({
    selector: 'app-catalog-card',
    templateUrl: './catalog-card.component.html',
    styleUrls: ['./catalog-card.component.scss'],
    standalone: false
})
export class CatalogCardComponent implements OnInit {
  @Input()  data : any = {}

  constructor(public utilService: UtilService,public router: Router ) {
  
  }

  ngOnInit(): void {
    //debugger;    

    let cat_image_id = this.data.category_image;
    let prod_image_id = this.data.product_image;


    //console.log('image id : ', cat_image_id);
    if(cat_image_id!=null && cat_image_id!=''){
        let image_path = this.utilService.getImageUrl(cat_image_id);
        Object.assign(this.data, {'catalog_image_path': image_path});
    }
    else if(prod_image_id!=null && prod_image_id!=''){
        let image_path = this.utilService.getImageUrl(prod_image_id);  
        Object.assign(this.data, {'catalog_image_path': image_path});
    }

    if(this.data.category_name){
      //console.log("Category component calling");
      const catalog_type = "category";
      Object.assign(this.data, {'catalog_type': catalog_type});
      //console.log("category object : ", this.data);
    }
    else if(this.data.product_name){
      //console.log("Product component calling");
      const catalog_type = "product";
      Object.assign(this.data, {'catalog_type': catalog_type});
      //console.log("product object : ", this.data);
    }
  }
  
  openScheduleDemoForm(event){
    let platform = "hospital-healthcare-platform";
    let tab = "";
    let productId = event.id;
    this.router.navigate(['schedule-demo'],{ queryParams: { platform: platform , tab :  tab, product : productId}});
  }
  openDownloadBrochureForm(event){
    let platform = "hospital-healthcare-platform";
    let tab = "";
    let productId = event.id;
    this.router.navigate(['download-brochure'],{ queryParams: { platform: platform , tab :  tab, product : productId}});
  }

  openCatalogDetails(productName, productDetails){

    const main_body     = document.getElementsByTagName("body");
    const main_modal    = document.getElementById('catalogModal');
    const modal_title   = document.getElementById('popupTitle');
    const modal_body    = document.getElementById('long-description');
    
    main_modal.classList.add("show");
    modal_title.innerHTML = productName;
    modal_body.innerHTML  = productDetails;

    main_modal.style.display = "block";
    main_body[0].style.overflow = "hidden";

  }

  openProductDetails(pdata){
    
    this.router.navigate(['products/'+pdata.id ]);
    
  }

}
